import React, { useMemo } from "react";
// Assets
import IOne21 from "assets/one21.png";
import ISofiaFull from "assets/i-sofia-full";
import IPlus from "assets/i-plus";

// Ctx
import { SofiaMagicStudioProvider } from "contexts/sofia-magic-studio-ctx";
import { useGlobalCtx } from "contexts/GlobalContext";

// Component
import Button from "components/v1/Button";
import TidiedUpPhotoOrganism from "components/organism/sofia-magic-studio/tidied-up-photo";
import ModalTambahKredit from "components/molecules/sofia-magic-studio/modal-tambah-kredit";
import ModalTambahKreditDetail from "components/molecules/sofia-magic-studio/modal-tambah-kredit-detail";
import ModalKonfirmasi from "components/molecules/sofia-magic-studio/modal-result";

// Apis
import {
  useGetSofiaBalance,
} from "api/sofia-magic-studio";

const TidiedUpPhoto = () => {
  
  const { data: balanceData } = useGetSofiaBalance();

  const balance = useMemo(
    () => balanceData?.data?.data?.balance_credits || 0,
    [balanceData],
  );

  const { profile } = useGlobalCtx();
  const [isOpenModal, setIsOpenModal] = React.useState(""); // "kredit" | "payment"

  const handleCloseModal = () => {
    setIsOpenModal("");
  };

  const handleOpenModal = (type) => {
    setIsOpenModal(type);
  };


  return (
    <>
      <div className="absolute top-0 left-0 right-0 z-10 w-screen min-h-screen bg-[#fff]">
        <div className="px-6 py-[14px] bg-white flex items-center justify-between">
          <div className="flex items-start gap-0.5">
            <ISofiaFull width="74" height="24" />
            <p className="text-[11px] tracker-[0.11px] leading-[15px] font-inter-bold text-[#1B67DA]">
              Gambar
            </p>
          </div>

          <div className="flex items-center justify-center gap-2">
            <div className="flex items-center gap-1">
              <span className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#252526]">
                {balance?.toLocaleString("id-ID")}
              </span>
              <span className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#808285]">
                kredit
              </span>
            </div>
          </div>
        </div>
        <TidiedUpPhotoOrganism />
        <div className="flex items-center justify-between px-6 py-[14px] border-t border-solid border-[#D8D8D9]">
          <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#252526]">
            CENTURY 21 {profile?.company?.name}{" "}
            <span className="text-[#808285]">© 2026.</span>
          </p>

          <div className="flex items-center gap-1">
            <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#808285]">
              Powered by
            </p>
            <img
              className="w-[43.922px] h-[43.922px] object-contain"
              src={IOne21}
              alt="one21"
            />
          </div>
        </div>
      </div>
      <ModalTambahKredit
        onSelect={() => handleOpenModal("payment")}
        isOpen={isOpenModal === "kredit"}
        onClose={handleCloseModal}
      />
      <ModalTambahKreditDetail
        isOpen={isOpenModal === "payment"}
        onClose={handleCloseModal}
        onBack={() => handleOpenModal("kredit")}
        onSelect={() => handleOpenModal("success")}
      />
      <ModalKonfirmasi
        isOpen={isOpenModal === "success"}
        onClose={handleCloseModal}
        title="Pembayaran berhasil"
        description="Kredit yang dipilih sudah bisa digunakan atau didistribusikan ke marketing kantor."
        leftBtnText="Kembali"
        rightBtnText="Selesai"
        rightBtnAction={handleCloseModal}
        rightBtnVariant="primary"
      />
    </>
  );
};

const Wrapper = () => {
  return (
    <SofiaMagicStudioProvider>
      <TidiedUpPhoto />
    </SofiaMagicStudioProvider>
  );
};

export default Wrapper;
